<template>
  <div class="login--panel col-xl-6 col-sm-12 display-flex flex-wrap">
    <section class="display-flex flex-wrap justify-content-center align-items-center w-100 pl-5 pr-5">
      <div class="d-block " style="margin: 0 auto">
        <div class="display-flex flex-wrap w-100 justify-content-center">
          <img src="../../assets/logo.png" style="margin-bottom: 20px">
          <section class="remindPassword--panel-header">
            <h2 style="letter-spacing: 4px">
              Vouchery Blue Diamond
            </h2>
            <div class="w-100 display-flex justify-content-center mt-3 mb-5">
              <h5 style="color: #bdbdbd; text-align: center">Resetowanie hasła za pomocą konta e-mail</h5>
            </div>
          </section>
          <form @submit.prevent="onRemindPassword()" class="remindPassword--form">
            <fieldset class="w-100">
              <v-text-field
                v-validate="'required|email'"
                type="email"
                v-model="formData.email"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
                browser-autocomplete="off"
                label="Adres e-mail">
              </v-text-field>
            </fieldset>
            <button type="submit"
                    id="remindPassword"
                    class="button--primary mt-4">
              Resetuj hasło
            </button>
            <div class="display-flex mt-4 w-100 justify-content-center">
              <router-link
                :to="'/login'"
                class="register--link">
                Zaloguj się
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'Remind-password',
    data() {
      return {
        formData: Object({}),
      };
    },
    methods: {
      ...mapActions('AuthStore', ['sendEmail']),
      onRemindPassword() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.sendEmail(this.formData)
                .then(() => {
                  this.$router.push('/login');
                });
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../styles/remindPassword";
</style>
